import UpdateFinance from "../features/finance/UpdateFinance"

const UpdateFinancePage = () => {
    return (
        <>
            <UpdateFinance />
        </>
    )
}

export default UpdateFinancePage